import { InjectionToken } from "@angular/core";

export interface IAMAccountConfig {
  rootAccountIdentity: string;
}

export const IAM_ACCOUNT_CONFIG = new InjectionToken<IAMAccountConfig>(
  "IAM_ACCOUNT_CONFIG"
);
